import React from 'react'
import CareerDetails from '../CareerDetails'
import jobList from './positionList.json'

const SeniorBackendDeveloper = () => {
  return <CareerDetails {...jobList[1]} />
}

export default SeniorBackendDeveloper
